import {
    getZoneLoading,
    getZoneReject,
    getZoneRequest,
    getZoneSuccess
} from "../../actions/zone/getAll";

export const getZone = (formData) => async (dispatch, getState) => {
    dispatch(getZoneLoading());
    try {
        const { data } = await getZoneRequest(formData, getState);
        dispatch(getZoneSuccess(data))
    } catch (error) {
        dispatch(getZoneReject(error))
    }
    return Promise.resolve();
};